import { createFileRoute } from "@tanstack/react-router";
import { HubShell, Section, PortalTable, FaqAccordion, hubHead } from "@/components/work-hubs/HubShell";

export const Route = createFileRoute("/app-testing/portals")({
  head: () =>
    hubHead(
      "/app-testing/portals",
      "App Tester Portals — UserTesting, PlaytestCloud, Testlio, Trymata & Captcha Typing | DrHint",
      "Compare established user-testing and captcha typing platforms by reported pay, accepted regions and test type, with official registration links.",
    ),
  component: Page,
});

const ROWS = [
  { name: "UserTesting", url: "https://www.usertesting.com/get-paid-to-test", type: "Recorded usability tests, live interviews", pay: "Commonly ~$4–$10 per short test; more for interviews", regions: "Many countries; most tests target US/UK/CA", badge: "Usability" },
  { name: "PlaytestCloud", url: "https://www.playtestcloud.com/", type: "Mobile game playtests", pay: "Commonly ~$9 per 15-min playtest", regions: "Worldwide, English speakers", badge: "Gaming" },
  { name: "Testlio", url: "https://testlio.com/", type: "Functional / QA testing", pay: "Hourly or per-project, skill-based", regions: "Worldwide, selective", badge: "QA" },
  { name: "Trymata", url: "https://trymata.com/", type: "Website & app usability tests", pay: "Commonly ~$10 per test", regions: "Varies by study", badge: "Usability" },
  { name: "5th Captcha", url: "https://5thcaptcha.com/", type: "Captcha typing with USDT payouts", pay: "Free plan: 10 captchas/day at $0.01 each; higher rates need paid tiers ($50–$1,000 up front)", regions: "Worldwide", badge: "Captcha typing" },
];

function Page() {
  return (
    <HubShell
      crumbs={[{ label: "Home", to: "/" }, { label: "App Testing", to: "/app-testing" }, { label: "Portals" }]}
      step={3}
      eyebrow="Testing Hub"
      title="Official Tester Portals"
      intro="These platforms have paid testers for years. Pay figures are commonly reported ranges, not guarantees — the exact amount is shown on each test before you start."
      back={{ to: "/app-testing/guidelines", label: "Back to guidelines" }}
    >
      <Section title="Directory">
        <PortalTable rows={ROWS} />
        <p className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 text-sm leading-relaxed">
          <b>A note on 5th Captcha:</b> its free plan is only 10 captchas a day (about $0.10), and earning more requires buying a paid tier ($50–$1,000 up front) plus referral recruiting. Any site that asks you to pay to unlock higher earnings deserves extra caution — never spend money you cannot afford to lose, and remember that no genuine employer charges you to work.
        </p>
      </Section>
      <Section title="Frequently asked questions">
        <FaqAccordion faqs={[
          { q: "Is it free to join?", a: "The four testing platforms are free. 5th Captcha also has a free plan, but only 10 captchas a day — its higher-earning tiers cost $50–$1,000 up front. Never pay just to become a tester." },
          { q: "How do I get paid?", a: "Mostly through PayPal; some use bank transfer or Payoneer. Check that your payment method works in your country first." },
          { q: "Why am I not getting tests?", a: "Tests target specific demographics and countries. Complete your profile, check often, and join more than one platform." },
          { q: "Can I test on my phone only?", a: "Game playtests often work on mobile. Most website tests need a computer with a microphone." },
        ]} />
      </Section>
    </HubShell>
  );
}
